/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'dots': {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<circle pid="0" class="dot" cx="24" cy="6" r="5"/><circle pid="1" class="dot" cx="24" cy="42" r="5"/><circle pid="2" class="dot" cx="24" cy="24" r="5"/>'
  }
})
